const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/artists/$id.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { getFindAllOrganizationUnitsSuspenseQueryOptions, getFindArtistSuspenseQueryOptions } from '@api';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { t } from 'i18next';
export const Route = createFileRoute('/_rootLayout/artists/$id')({
  beforeLoad: async ({
    params,
    matches
  }) => {
    const lastMatch = matches[matches.length - 1];
    if (lastMatch.id.endsWith(`/artists/${params.id}`)) {
      redirect({
        to: '/artists/$id/general',
        params: {
          id: params.id
        },
        throw: true,
        replace: true
      });
    }
  },
  loader: async ({
    context: {
      queryClient
    },
    params
  }) => {
    queryClient.ensureQueryData(getFindArtistSuspenseQueryOptions(params.id));
    queryClient.ensureQueryData(getFindAllOrganizationUnitsSuspenseQueryOptions());
    return {
      crumb: t('NAVIGATION.ARTISTS'),
      to: '/artists'
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});